import { cn, RadioGroup, RadioGroupItem, RadioGroupItemProps, RadioGroupProps } from '@landler/component-library';
import React from 'react';
import { UseFormReturn } from 'react-hook-form';

import { FormControl, FormField, FormItem, FormLabel } from '@/components/Form';

import { useControlsContext } from './Form';

type FormRadioGroupProps = RadioGroupProps & {
  name: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  controlsform?: UseFormReturn<any>;
};

export const FormRadioGroup = ({ name, className, onValueChange, controlsform, ...delegated }: FormRadioGroupProps) => {
  // TODO: MVP-CW refactor to use only one context
  const formWidgetControlsform = useControlsContext();
  const controls = controlsform ?? formWidgetControlsform;

  return (
    <FormField
      name={name}
      control={controls.control}
      render={({ field: { onChange, ...field } }) => (
        <FormItem>
          <FormControl>
            <RadioGroup
              className={cn('flex flex-col gap-2', className)}
              {...field}
              onValueChange={(...args) => {
                onValueChange?.(...args);
                onChange(...args);
              }}
              data-testid={`radiogroup-${field.name}`}
              {...delegated}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};

export const FormRadioItem = ({
  value,
  label,
  removeFormItems,
  formName,
  ...delegated
}: RadioGroupItemProps & { label: React.ReactNode; removeFormItems?: string[]; formName?: string }) => {
  const { setValue } = useControlsContext();

  const handleOnClick = () => {
    if (removeFormItems) {
      removeFormItems.forEach((item) => {
        setValue(item, null);
      });
    }

    if (formName) {
      setValue(formName, value);
    }
  };

  return (
    <FormItem className='flex items-center gap-2 w-fit'>
      <FormControl>
        <RadioGroupItem value={value} onClick={handleOnClick} {...delegated} />
      </FormControl>
      <FormLabel className='typography-body2 text-text-primary'>{label}</FormLabel>
    </FormItem>
  );
};
